module.exports = __webpack_public_path__ + "img/16l008-12.53213285.jpg";